import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ViewEncapsulation } from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { AnimationOptions } from 'ngx-lottie'
import { firstValueFrom, Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { CategoryService } from 'src/app/service/data/category.service'
import { DictionaryService } from 'src/app/service/data/dictionary.service'
import { PairService } from 'src/app/service/data/pair.service'
import { TagService } from 'src/app/service/data/tag.service'
import { WordService } from 'src/app/service/data/word.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Article, ArticlesByLanguage, Languages, PartOfSpeech, Themes } from '../../enums/enums'
import { SelectOption } from '../../interfaces/word'
import { DdcButtonSOneComponent } from '../ddc-button-s-one/ddc-button-s-one.component'
import { DdcDeleteDialogComponent } from '../ddc-delete-dialog/ddc-delete-dialog.component'
import { DdcElemChooserOneComponent } from '../ddc-elem-chooser-one/ddc-elem-chooser-one.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'
@Component({
  selector: 'ddc-edit-pair-dialog',
  templateUrl: './ddc-edit-pair-dialog.component.html',
  styleUrl: './ddc-edit-pair-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    ReactiveFormsModule,
    DdcElemChooserOneComponent,
    DdcButtonSOneComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcEditPairDialogComponent {
  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  _theme: string
  _addedField: string = ''
  private themeSubscription: Subscription

  _isCreateBtnLoading = false
  _submitBtnText = 'Edit'
  _privacyMaxlength: number = 4
  _wordMaxlength: number = 100
  _exampleMaxlength: number = 5000
  _definitionMaxlength: number = 10000
  _posMaxlength: number = 3
  _articleMaxlength: number = 3
  _addError: string = ''

  _editedPair: any

  _selectedChipOptions: string[] = []
  _selectedPrivacyChipOptions: string = ''
  _selectedPrivacy2ChipOptions: string = ''
  _userTags: any[] = []
  _userCats: any[] = []
  _userDics: any[] = []

  _loadedCats: boolean = false
  _loadedTags: boolean = false
  _loadedDics: boolean = false

  _selectedTags: { id: number; label: string }[] = []
  _selectedTags2: { id: number; label: string }[] = []
  _selectedDics: { id: number; label: string }[] = []
  _selectedArticle: string = null
  _selectedArticle2: string = null
  _selectedPos: string = null
  _selectedWordId: number = 0
  _selectedWordId2: number = 0
  _selectedLanguage: string
  _selectedCategory: { id: number; label: string }[] = []
  _selectedCategory2: { id: number; label: string }[] = []

  languages: SelectOption[] = []
  articles: SelectOption[] = []
  articles2: SelectOption[] = []
  poses: SelectOption[] = []

  _selectedLngHasArticle: boolean = false
  _selectedLngHasArticle2: boolean = false

  _isEditBtnLoading = false
  _maxLength: number = 100
  _editError: string = ''
  _editedField1: string = ''
  _editedField2: string = ''

  _deletedField: boolean = false
  _deleteFromDDC: boolean = false
  _deleteFromDic: boolean = false

  _isPairEdited: boolean = false

  _type: string = ''
  _element: any
  _hasDic: boolean = false
  _targetDicId: number

  _form = new FormGroup({
    // ! Word 1
    _1_language: new FormControl('', [Validators.required]),

    _1_article: new FormControl(null, []),

    _1_word: new FormControl('', [Validators.required, Validators.maxLength(this._wordMaxlength)]),

    _1_pos: new FormControl(null, []),

    _1_example: new FormControl(null, [Validators.maxLength(this._exampleMaxlength)]),

    _1_definition: new FormControl(null, [Validators.maxLength(this._definitionMaxlength)]),

    // ! privacy
    _1_privacy: new FormControl('P01', [
      Validators.required,
      Validators.maxLength(this._privacyMaxlength),
    ]),

    // ! Word 2
    _2_language: new FormControl('', [Validators.required]),

    _2_article: new FormControl(null, []),

    _2_word: new FormControl('', [Validators.required, Validators.maxLength(this._wordMaxlength)]),

    _2_pos: new FormControl(null, []),

    _2_example: new FormControl(null, [Validators.maxLength(this._exampleMaxlength)]),

    _2_definition: new FormControl(null, [Validators.maxLength(this._definitionMaxlength)]),

    // ! privacy
    _2_privacy: new FormControl('P01', [
      Validators.required,
      Validators.maxLength(this._privacyMaxlength),
    ]),
  })

  // This is the option that uses the package's AnimationOption interface
  options: AnimationOptions = {
    path: '/assets/lottie/green-tick.json',
    loop: false, // Set loop to false for a single playthrough
    autoplay: true,
  }

  partOfSpeeches: any

  constructor(
    private logger: DdcLoggerService,
    private fb: FormBuilder,
    public themeService: ThemeService,
    private cat_service: CategoryService,
    private tag_service: TagService,
    private word_service: WordService,
    private pair_service: PairService,
    private dic_service: DictionaryService,
    public dialog: MatDialog,
    private editDialogRef: MatDialogRef<DdcEditPairDialogComponent>,
    private deleteDialogRef: MatDialogRef<DdcDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this._element = data.element
    if (data.hasDic) {
      this._hasDic = data.hasDic
      this._targetDicId = data.dicId
    }

    if (data.command === 'delete') {
      this.openDeleteDialog()
    }
    this._selectedPrivacyChipOptions = this._element.word_1.privacy
    this._selectedPrivacy2ChipOptions = this._element.word_2.privacy

    this._selectedCategory[0] = this._element.word_1.category
    this._selectedCategory2[0] = this._element.word_2.category
    this._selectedTags = this._element.word_1.tags
    this._selectedTags2 = this._element.word_2.tags
    this._selectedDics = this._element.dictionaries

    this._selectedWordId = this._element.word_1.id
    this._selectedWordId2 = this._element.word_2.id

    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })

    this.getLanguages()
    this.getArticles()
    this.getPos()
    this.getUserTags()
    this.getUserCats()
    this.getUserDics()

    // Initialize your form group
    this._form = this.fb.group({
      _1_language: [this._element.word_1.language],
      _1_article: [this._element.word_1.article],
      _1_word: [this._element.word_1.word],
      _1_pos: [this._element.word_1.pos],
      _1_example: [this._element.word_1.example],
      _1_definition: [this._element.word_1.definition],
      _1_privacy: [this._selectedPrivacyChipOptions],
      _2_language: [this._element.word_2.language],
      _2_article: [this._element.word_2.article],
      _2_word: [this._element.word_2.word],
      _2_pos: [this._element.word_2.pos],
      _2_example: [this._element.word_2.example],
      _2_definition: [this._element.word_2.definition],
      _2_privacy: [this._selectedPrivacy2ChipOptions],
    })
  }

  getPos(): void {
    this.logger.info('DdcEditPairDialogComponent: getPos()')

    const posArray = Object.values(PartOfSpeech) as string[]

    this.poses.push({
      raw_value: null,
      view_value: 'None',
    })

    // Loop through the enum values and create SelectOption objects
    for (const value of posArray) {
      this.poses.push({
        raw_value: value,
        view_value: value,
      })
    }
  }

  updateSelectedTags(tags: any): void {
    this._selectedTags = tags
  }

  updateSelectedCat(cat: any): void {
    this._selectedCategory = cat
  }

  updateSelectedTags2(tags: any): void {
    this._selectedTags2 = tags
  }

  updateSelectedCat2(cat: any): void {
    this._selectedCategory2 = cat
  }

  updateSelectedDics(dictionaries: any): void {
    this.logger.info('DdcEditPairDialogComponent: updateSelectedDics() dictionaries:', dictionaries)
    this._selectedDics = dictionaries
  }

  getLanguages(): void {
    this.languages = Object.entries(Languages).map(([key, [viewValue, rawValue]]) => ({
      raw_value: rawValue,
      view_value: viewValue,
    }))
  }

  onLanguageChange(event: any): void {
    this.logger.info('DdcEditPairDialogComponent: onLanguageChange() event:', event)
    const selectedLng = event.value

    this.articles = []
    this.articles.push({
      raw_value: null,
      view_value: 'None',
    })

    const articlesArray = ArticlesByLanguage[selectedLng]

    if (articlesArray != undefined) {
      this._selectedLngHasArticle = true
    } else {
      this._selectedLngHasArticle = false
      this._selectedArticle = null
    }

    for (const value of articlesArray) {
      this.articles.push({
        raw_value: value,
        view_value: value,
      })
    }
  }

  onLanguageChange2(event: any): void {
    this.logger.info('DdcEditPairDialogComponent: onLanguageChange2() event:', event)
    const selectedLng = event.value

    this.articles2 = []
    this.articles2.push({
      raw_value: null,
      view_value: 'None',
    })

    const articlesArray = ArticlesByLanguage[selectedLng]

    if (articlesArray != undefined) {
      this._selectedLngHasArticle2 = true
    } else {
      this._selectedLngHasArticle2 = false
      this._selectedArticle2 = null
    }

    for (const value of articlesArray) {
      this.articles2.push({
        raw_value: value,
        view_value: value,
      })
    }
  }

  getArticles(): void {
    this.logger.info('DdcEditPairDialogComponent: getArticles()')
    const articlesArray = Object.values(Article) as string[]

    this.articles.push({
      raw_value: null,
      view_value: 'None',
    })

    // Loop through the enum values and create SelectOption objects
    for (const value of articlesArray) {
      this.articles.push({
        raw_value: value,
        view_value: value,
      })
    }
  }

  getUserTags(): void {
    this.logger.info('DdcEditPairDialogComponent: getUserTags()')
    this.tag_service.get_tags().subscribe((res: any) => {
      if (res) {
        this._userTags = res
        this._loadedTags = true
      }
    })
  }

  getUserDics(): void {
    this.logger.info('DdcEditPairDialogComponent: getUserDics()')
    this.dic_service.get_dics(true).subscribe((res: any) => {
      if (res) {
        this._userDics = res
        this._loadedDics = true
      }
    })
  }

  getUserCats(): void {
    this.logger.info('DdcEditPairDialogComponent: getUserCats()')
    this.cat_service.get_cats().subscribe((res: any) => {
      if (res) {
        this._userCats = res
        this._loadedCats = true
      }
    })
  }

  hasNewCat(selectedCat: { id: number; label: string }[]): boolean {
    return !this._userCats.some(cat => cat.label.includes(selectedCat[0].label))
  }

  hasNewTags(selectedTags: { id: number; label: string }[]): { res: boolean; list: string[] } {
    const newTags: string[] = []

    for (const selectedTag of selectedTags) {
      const tagExists = this._userTags.some(userTag => userTag.label === selectedTag.label)

      if (!tagExists) {
        newTags.push(selectedTag.label)
      }
    }
    if (newTags.length == 0) return { res: false, list: [] }
    else return { res: true, list: newTags }
  }

  async handleCat(selectedCat: { id: number; label: string }[]): Promise<boolean> {
    try {
      if (
        selectedCat != null &&
        selectedCat.length != 0 &&
        selectedCat[0] != null &&
        this.hasNewCat(selectedCat)
      ) {
        const res: any = await firstValueFrom(this.cat_service.add_cat(selectedCat[0].label))
        if (res.success) {
          return true
        } else {
          this._addError = 'Cannot add new category: \"' + selectedCat[0].label + '\"'
          return false
        }
      }
      return true
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: handleCat() | Error:', error)
      return false
    }
  }

  async handleTags(selectedTags: { id: number; label: string }[]): Promise<boolean> {
    try {
      if (
        selectedTags != null &&
        selectedTags.length != 0 &&
        selectedTags[0] != null &&
        this.hasNewTags(selectedTags).res
      ) {
        const res: { success: boolean; res: any }[] = []
        for (const tag of this.hasNewTags(selectedTags).list) {
          this.logger.info('DdcEditPairDialogComponent: handleTags() tag:', tag)
          const res_elem: any = await firstValueFrom(this.tag_service.add_tag(tag))
          res.push(res_elem)
          if (!res_elem.success) {
            this._addError = 'Cannot add new tag: \"' + tag + '\"'
          }
        }
        const allTagsSuccess = res.every(result => result.success)

        if (allTagsSuccess) {
          return true
        } else {
          const failedTagsResults = res.filter(result => !result.success)
          if (failedTagsResults.length === 0) {
          } else {
            const failedLabels = failedTagsResults.map(result => result.res.label)
            this._addError = 'Cannot add new tag: \"' + failedLabels + '\"'
          }
        }
      }
      return true
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: handleTags() | Error:', error)
      return false
    }
  }

  get w1(): any {
    return this._form.get('_1_word')
  }

  get w2(): any {
    return this._form.get('_2_word')
  }

  get def1(): any {
    return this._form.get('_1_definition')
  }

  get def2(): any {
    return this._form.get('_2_definition')
  }

  get exp1(): any {
    return this._form.get('_1_example')
  }

  get exp2(): any {
    return this._form.get('_2_example')
  }

  isFormValid(): boolean {
    const lng = this._form.get('_1_language').valid
    const art = this._form.get('_1_article').valid
    const word = this._form.get('_1_word').valid
    const pos = this._form.get('_1_pos').valid
    const exp = this._form.get('_1_example').valid
    const def = this._form.get('_1_definition').valid

    if (lng && art && word && pos && exp && def) {
      return true
    }

    return false
  }

  async editPair(): Promise<boolean> {
    this.logger.info('DdcEditPairDialogComponent: editPair()')
    try {
      return true
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: editPair() | Error:', error)
      return false
    }
  }

  async editWord(order: number): Promise<[boolean, number]> {
    this.logger.info('DdcEditPairDialogComponent: editWord() order:', order)
    try {
      const editedWord = {
        id: order == 1 ? this._selectedWordId : this._selectedWordId2,
        language: order == 1 ? this._form.value._1_language : this._form.value._2_language,
        article: order == 1 ? this._form.value._1_article : this._form.value._2_article,
        word: order == 1 ? this._form.value._1_word : this._form.value._2_word,
        pos: order == 1 ? this._form.value._1_pos : this._form.value._2_pos,
        example: order == 1 ? this._form.value._1_example : this._form.value._2_example,
        definition: order == 1 ? this._form.value._1_definition : this._form.value._2_definition,
        privacy: order == 1 ? this._form.value._1_privacy : this._form.value._2_privacy,
        category: order == 1 ? this._selectedCategory[0] : this._selectedCategory2[0],
        tags: order == 1 ? this._selectedTags : this._selectedTags2,
      }
      this.logger.info('DdcEditPairDialogComponent: editWord() | editedWord:', editedWord)
      const res: any = await firstValueFrom(this.word_service.edit_word(editedWord))

      this._isEditBtnLoading = false
      this._submitBtnText = 'Edit'

      if (res.success) {
        this._editError = ''
        if (order == 1) this._editedField1 = res.res.word
        else this._editedField2 = res.res.word

        return [true, res.res.id]
      } else {
        this.logger.error('DdcEditPairDialogComponent: editWord() | failed: res:', res)
        this._editError = res.res
        if (order == 1) this._editedField1 = ''
        else this._editedField2 = ''
        return [false, 0]
      }
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: editWord() | error:', error)
      return [false, 0]
    }
  }

  async getPair(id: number): Promise<[boolean, any]> {
    try {
      const res: any = await firstValueFrom(this.pair_service.get_pair(id))
      if (res.success) {
        return [true, res.res]
      } else return [false, 0]
    } catch (error) {
      return [false, 0]
    }
  }

  async handleDics(selectedDics: { id: number; label: string }[]): Promise<boolean> {
    try {
      this.logger.info('DdcEditPairDialogComponent: handleDics() selectedDics:', selectedDics)
      const res: any = await firstValueFrom(
        this.dic_service.edit_dics_of_pair(this._element.id, selectedDics),
      )

      if (!res.success) {
        this._addError = 'Cannot edit dictionaries.'
        return false
      }
      return true
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: handleDics() | Error:', error)
      return false
    }
  }

  async edit(): Promise<void> {
    this.logger.info('DdcEditPairDialogComponent: edit()')
    if (!this.isFormValid()) return
    this._isEditBtnLoading = true
    if (this._selectedTags && this._selectedTags.length == 0) this._selectedTags = null

    if (!this._selectedCategory[0]) this._selectedCategory[0] = null

    if (this._selectedTags2 && this._selectedTags2.length == 0) this._selectedTags2 = null

    if (!this._selectedCategory2[0]) this._selectedCategory2[0] = null

    try {
      const handledCat = await this.handleCat(this._selectedCategory)

      if (handledCat) {
        const handledTags = await this.handleTags(this._selectedTags)

        if (handledTags) {
          const handledDics = await this.handleDics(this._selectedDics)
          if (handledDics) {
            const [handledWord, firstWordId] = await this.editWord(1)

            // For Pair
            if (handledWord) {
              const handledCat2 = await this.handleCat(this._selectedCategory2)

              if (handledCat2) {
                const handledTags2 = await this.handleTags(this._selectedTags2)

                if (handledTags2) {
                  const [handledWord2, secondWordId] = await this.editWord(2)

                  if (handledWord2) {
                    const [handledPair, editedPair] = await this.getPair(this._element.id)
                    this._editedPair = editedPair
                    this._isPairEdited = true
                    this._isEditBtnLoading = false
                  } else this.logger.error('handledWord2: error')
                } else {
                  this.logger.error('handledTags2: error')
                }
              } else {
                this.logger.error('handledCat2: error')
              }
            } else this.logger.error('handledWord: error')
          } else {
            this.logger.error('handledDics: error')
          }
        } else {
          this.logger.error('handledTags: error')
        }
      } else {
        this.logger.error('handledCat: error')
      }
    } catch (error) {
      this.logger.error('DdcEditPairDialogComponent: edit() | Error:', error)
    }
  }

  closeDialog(): void {
    this.editDialogRef.close('pair')
    if (this._deletedField) this.editDialogRef.close({ removed: true, element: this.data.element })
    else this.editDialogRef.close({ edited: this._isPairEdited, element: this._editedPair })
  }

  openDeleteDialog(): void {
    this.logger.info('DdcEditPairDialogComponent: openDeleteDialog()')
    this.logger.info(
      'DdcEditPairDialogComponent: openDeleteDialog() | this._element:',
      this._element,
    )
    this.logger.info('DdcEditPairDialogComponent: openDeleteDialog() | this._type:', this._type)

    const dialogRef = this.dialog.open(DdcDeleteDialogComponent, {
      data: {
        hasDic: this._hasDic,
        type: 'pair',
        element: {
          word: '"' + this._element.word_1.word + ' = ' + this._element.word_2.word + '"',
        },
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      // Handle any actions after the dialog is closed, e.g., updating the user's profile picture.
      if (result === 'delete-element') {
        this.pair_service.delete_pair(this.data.element.id).subscribe((res: any) => {
          if (res.success) {
            this._editError = ''
            this._editedField1 = this._form.value._1_word
            this._editedField2 = this._form.value._2_word
            this._deletedField = true
            this._deleteFromDDC = true
          } else {
            this.logger.error(
              'DdcEditPairDialogComponent: openDeleteDialog() | dialogRef.afterClosed() | delete_pair: failed: res:',
              res,
            )
            this._editError = res.res

            this._editedField1 = ''
            this._editedField2 = ''

            this._deletedField = true
          }
          this._isEditBtnLoading = false
          this._submitBtnText = 'Edit'
        })
      } else if (result === 'delete-element-in-dic') {
        this.dic_service
          .remove_pairs_from_dic(this._targetDicId, [this.data.element.id])
          .subscribe((res: any) => {
            if (res.success) {
              this._editError = ''
              this._editedField1 = this._form.value._1_word
              this._editedField2 = this._form.value._2_word
              this._deletedField = true
              this._deleteFromDic = true
            } else {
              this.logger.error(
                'DdcEditPairDialogComponent: openDeleteDialog() | dialogRef.afterClosed() | remove_pairs_from_dic: failed: res:',
                res,
              )
              this._editError = res.res
              this._editedField1 = ''
              this._editedField2 = ''
              this._deletedField = true
            }
            this._isEditBtnLoading = false
            this._submitBtnText = 'Edit'
          })
      }
    })
  }
}
